export default __webpack_public_path__ + "static/media/SearchBlue.24e52da6.svg";